import { deleteCustomersCustomerIdPushSubscriptions } from '@agos/api-client/customers'
import type { CustomerPushSubscriptionsRemoved } from '@agos/api-client/model'

/**
 * Removing a customer's push subscriptions from the drawer - `FRONTEND.md` §9.735, `BACKEND.md` §10A.381.
 *
 * Through the generated function now. Lane N wrote this as a `customFetch` because the endpoint was newer than the
 * committed spec (§9.509's lesson), and `typed-fetches.test.ts` held the path on its *awaiting regeneration* list; the
 * spec was exported from the running backend and the client regenerated on 2026-10-07, so the list cleared and the
 * path, the method and the answer's type are the spec's rather than this file's.
 */

/** What the server writes - `CustomerDtos.PushSubscriptionsRemoved`: the rows it deleted, `0` being an answer. */
export type PushSubscriptionsRemoved = CustomerPushSubscriptionsRemoved

export async function removePushSubscriptions(customerId: number): Promise<PushSubscriptionsRemoved> {
  return deleteCustomersCustomerIdPushSubscriptions(customerId)
}

/**
 * How many the server says it removed, or `null` when the answer is not that shape - so the toast says the
 * server's figure or none, never the drawer's own guess.
 */
export function removedCountOf(payload: unknown): number | null {
  if (typeof payload !== 'object' || payload === null) return null
  const removed = (payload as { removed?: unknown }).removed
  return typeof removed === 'number' && Number.isInteger(removed) && removed >= 0 ? removed : null
}
